module.exports = __webpack_public_path__ + "img/hyal-9@2x.c78abe71.png";